import { FC } from 'react';
import { Heading } from '@chakra-ui/react';

type Props = {
  title: string;
  color?: string;
};

export const ListPageTitle: FC<Props> = ({
  title,
  color = 'blackAlpha.700',
}) => (
  <Heading as="h3" size="lg" fontSize="24px" color={color}>
    {title}
  </Heading>
);
